import api from "../../../../api/api";
import API_URL from "../../../../api/url";

const AppVersionRequest = {
  list: () =>
    api.get(`${API_URL.BASEURL}${API_URL.appVersionList}`),
  createOrUpdate: (values) =>
    api.post(`${API_URL.BASEURL}${API_URL.createOrUpdateAppVersion}`, values),
};

export default AppVersionRequest;
